import { Minus, Plus } from "lucide-react";

export function QuantityStepper({
  value,
  onChange,
  min = 1,
  max = 20,
  label,
}: {
  value: number;
  onChange: (n: number) => void;
  min?: number;
  max?: number;
  label?: string;
}) {
  return (
    <div
      className="inline-flex h-10 items-center border border-black/15"
      role="group"
      aria-label={label ?? "Quantity"}
    >
      <button
        type="button"
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={value <= min}
        aria-label="Decrease quantity"
        className="inline-flex h-full w-10 items-center justify-center text-black/70 transition hover:text-[#C6A15B] disabled:opacity-40"
      >
        <Minus className="h-3.5 w-3.5" />
      </button>
      <span
        aria-live="polite"
        className="inline-flex h-full w-10 items-center justify-center text-sm font-medium tabular-nums text-black"
      >
        {value}
      </span>
      <button
        type="button"
        onClick={() => onChange(Math.min(max, value + 1))}
        disabled={value >= max}
        aria-label="Increase quantity"
        className="inline-flex h-full w-10 items-center justify-center text-black/70 transition hover:text-[#C6A15B] disabled:opacity-40"
      >
        <Plus className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
